enum Enrollment {
  None = 0,
  Automatic = 1,
  Manual = 2,
}

export default Enrollment;
